import { ReportMenu } from '../interface/export-reports';

export const timesheetMockData: ReportMenu[] = [
  {
    title: 'TS 200 Timesheet Data Export to XLS (Date Range)',
    code: 'TS_200',
    isEnabled: true,
  },
  {
    title: 'TS 300 Track/Maximo Timesheet Variance',
    code: 'TS_300',
    isEnabled: true,
  },
];
